import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_PRODUCT} from '../../metamodel/Concept';

export default class ProductNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_PRODUCT;
	}
}
